interface ContinueState {
  requireEmail: boolean;
  email: string;
  checked: boolean;
  isLoading: boolean;
}

// An entered email needs the "not a personal email" tick even when the profile doesn't require one.
export function isContinueDisabled({
  requireEmail,
  email,
  checked,
  isLoading,
}: ContinueState) {
  if (requireEmail && !checked) return true;
  if (requireEmail && email.length === 0 && checked) return true;
  if (!requireEmail && email.trim().length > 0 && !checked) return true;
  return isLoading;
}
